import react from "react";
import { Outlet } from 'react-router-dom'
import Header from "../Header";
import navigation from '../../menu-items';


const MainLayout = () => {





    return (
        <div className="admin-body-section">
            <Header navigation={navigation} />

            <div className='main-panel'>
                <Outlet />
            </div>

        </div>
    )
}


export default MainLayout